import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Brand with Logo - Centered */}
        <div className="flex flex-col items-center space-y-4 mb-8">
          <div className="bg-gray-700 rounded-lg p-2">
            <img
              src="https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/o98yozmf_Screenshot%202025-04-21%20at%2018_edited_edite.avif"
              alt="Jussi Nukari Logo"
              className="h-12 w-auto object-contain"
            />
          </div>
          <div className="text-center">
            <h3 className="text-xl font-semibold mb-1">{t('heroTitle')}</h3>
            <p className="text-gray-400 text-sm">
              {t('heroSubtitle')}
            </p>
          </div>
        </div>

        {/* Contact Info - Centered Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-8">
          <div className="flex flex-col items-center text-center">
            <Phone className="w-5 h-5 mb-2" />
            <p className="text-sm text-gray-400 mb-1">{t('phone')}</p>
            <a
              href="tel:+358405066025"
              className="text-white hover:text-gray-300 transition-colors text-sm"
            >
              +358 40 5066025
            </a>
          </div>

          <div className="flex flex-col items-center text-center">
            <Mail className="w-5 h-5 mb-2" />
            <p className="text-sm text-gray-400 mb-1">{t('email')}</p>
            <a
              href="mailto:valokuvaaja@jussinukari.com"
              className="text-white hover:text-gray-300 transition-colors text-sm break-all"
            >
              valokuvaaja@jussinukari.com
            </a>
          </div>

          <div className="flex flex-col items-center text-center">
            <MapPin className="w-5 h-5 mb-2" />
            <p className="text-sm text-gray-400 mb-1">{t('location')}</p>
            <p className="text-white text-sm">
              Helsinki, Finland
            </p>
          </div>
        </div>

        {/* Copyright - Centered */}
        <div className="pt-8 border-t border-gray-600 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} {t('heroTitle')}. {t('allRightsReserved')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;